import React from 'react';
import Modal from 'react-modal';

export type ModalType = 'success' | 'error' | 'warning' | 'custom';

interface ModalBaseProps {
    isOpen: boolean;
    onRequestClose: () => void;
    title: string;
    type?: ModalType;
    children?: React.ReactNode;
    imageUrl?: string;
    footerButtons?: React.ReactNode[]; // Uno o dos botones
    contentLabel?: string;
    shouldCloseOnOverlayClick?: boolean;
    closeButton?: boolean;
}

const iconMap: Record<ModalType, React.ReactNode> = {
    success: (
        <span className='ciclii-modal-icon success' role='img' aria-label='Éxito' style={{ fontSize: '2.3rem', marginRight: 8 }}>🎉</span>
    ),
    error: (
        <span className='ciclii-modal-icon error' role='img' aria-label='Error' style={{ fontSize: '2.3rem', marginRight: 8 }}>❌</span>
    ),
    warning: (
        <span className='ciclii-modal-icon warning' role='img' aria-label='Advertencia' style={{ fontSize: '2.3rem', marginRight: 8 }}>⚠️</span>
    ),
    custom: (
        <></>
    ),
};

export const ModalBase: React.FC<ModalBaseProps> = ({
    isOpen,
    onRequestClose,
    title,
    type = 'success',
    children,
    imageUrl,
    footerButtons = [],
    contentLabel = 'Modal',
    shouldCloseOnOverlayClick = true,
    closeButton = true,
}) => {
    React.useEffect(() => {
        if (typeof document !== 'undefined') {
            Modal.setAppElement('#root');
        }
    }, []);
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className='ciclii-modal-content'
            overlayClassName='ciclii-modal-overlay'
            contentLabel={contentLabel}
            shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        >
            {closeButton && <button onClick={onRequestClose} aria-label='Cerrar' style={{ position: 'absolute', top: 14, right: 18, background: 'none', border: 'none', fontSize: '2rem', color: '#B57EDC', cursor: 'pointer' }}>×</button>}
            <div className='ciclii-modal-structure'>
                <div className={`ciclii-modal-header ${type}`}>
                    {iconMap[type]}
                    <h2>{title}</h2>
                </div>
                <div className='ciclii-modal-body'>
                    {imageUrl && (
                        <img src={imageUrl} alt='modal visual' className='ciclii-modal-image' />
                    )}
                    {children}
                </div>
                {footerButtons.length > 0 && (
                    <div className='ciclii-modal-footer'>
                        {footerButtons.map((btn, i) => (
                            <span key={i} className='ciclii-modal-footer-btn'>{btn}</span>
                        ))}
                    </div>
                )}
            </div>
        </Modal>
    );
};
